<div class="unified-search-result-item">
  <div class="details">
    <div class="title">
      <span [innerHTML]="item().title | boldSpan: term() | safeHtml"></span>
    </div>
    @if (item().description) {
      <div class="description" [semerisTooltip]="item().description">
        <span [innerHTML]="item().description | boldSpan: term() | safeHtml"></span>
      </div>
    }
    <div class="misc">
      @if (shouldDisplayType()) {
        <span class="type">{{ item().displayType || item().type | uppercase }}</span>
      }
      @if (item().refId) {
        <span class="refId" [innerHTML]="item().refId | boldSpan: term() | safeHtml"></span>
      }
      @if (item().displayShortName) {
        <span class="shortName" [innerHTML]="item().displayShortName | uppercase | boldSpan: term() | safeHtml"></span>
      }
    </div>
  </div>
  <div class="actions">
    @if (isBuiltIn()) {
      <mat-icon
        color="accent"
        stopPropagation
        class="icon hideable"
        [fastTooltip]="isAdd ? 'Add to My Topics' : 'Remove from My Topics'"
        (click)="onToggle()">
        {{ isAdd ? 'add' : 'remove' }}
      </mat-icon>
    }
    @if (isRouterLinkEnabled()) {
      <mat-icon
        [class.disabled-icon]="item()?.disabled"
        color="accent"
        [routerLink]="item()?.disabled ? undefined : item().routerLinkEdit"
        (click)="onClick($event)"
        class="icon hideable"
        fastTooltip="Edit"
        >edit</mat-icon
      >
    }

    <ng-container *permissions="[Permissions.READ_MARKET_COMPARE]">
      @if (item()?.showMarketCompare) {
        <mat-icon
          color="accent"
          class="icon hideable"
          stopPropagation
          [preventDefault]="true"
          (click)="onMarketCompare($event)"
          fastTooltip="Open Topic"
          >view_list</mat-icon
        >
      }
    </ng-container>

    @if (item()?.routerLinkFormula) {
      <mat-icon
        *permissions="[Permissions.WRITE_FORMULA]"
        color="accent"
        stopPropagation
        [preventDefault]="true"
        [routerLink]="item().routerLinkFormula"
        (click)="onFormulaClick($event)"
        class="icon hideable"
        fastTooltip="Formula Editor"
        >science</mat-icon
      >
    }

    <semeris-user-entity-icons [hideDescription]="true" [entity]="itemAsEntityBase()"></semeris-user-entity-icons>
  </div>
</div>
